/**
 * 帖子相关
 */

import axios from '../utils/http';


// 课件图片列表
const coursewareList = params => {
  return axios.request({
    data: {
      ...params
    },
    method: 'post',
    url: '/v7/courseware/detail'
  })
}

const courseware = {
  coursewareList
};

export default courseware